import type { ChatFolderSummary, ChatThreadSummary } from '../api/contracts'

/** The history list's threads in no folder, or in one that isn't listed
 * (deleted elsewhere), in their order (newest activity first). A folder's
 * own threads come from its query (`useChatFolderThreads`), not this list. */
export function unfiledThreads(
  threads: ChatThreadSummary[],
  folders: ChatFolderSummary[]
): ChatThreadSummary[] {
  const listed = new Set(folders.map((folder) => folder.folder_id))
  return threads.filter((thread) => !thread.folder_id || !listed.has(thread.folder_id))
}
